export default __webpack_public_path__ + "static/media/bg_desc_small_family.ea0fc085.jpg";